import React from "react";
import Logo from "../../layout/Logo/index.jsx";
import User from "../../../services/user.jsx";
import i18n from "../../../services/i18n.jsx";
import Loader from "../../layout/loader.jsx";
import Helpers from "../../../services/helpers.jsx";

import style from "./index.module.scss";

class ResetPasswordRequest extends React.Component {
  constructor(props) {
    super(props);
    this.reset = this.reset.bind(this);
    this.state = {
      token: "",
      password: "",
      passwordConfirm: "",
      loading: false,
      passwordConfirmError: false,
      passwordValidError: false,
    };
  }

  // On component mount, add class on body
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      this.setState({
        token,
      });
    }
    document.body.classList.add("fullscreen");
  }

  // On component unmount, remove class on body
  componentWillUnmount() {
    document.body.classList.remove("fullscreen");
  }

  // User password reset
  reset(event) {
    const { password, passwordConfirm } = this.state;
    if (password !== passwordConfirm) {
      this.setState({
        passwordConfirmError: true,
      });
      return;
    }

    if (!Helpers.isValidPassword(password)) {
      this.setState({
        passwordValidError: true,
      });
      return;
    }

    this.setState({ loading: true, passwordConfirmError: false });
    event.preventDefault();
    User.resetPassword({
      token: this.state.token,
      password: this.state.password,
    })
      .then(() => {
        this.setState({
          password: "",
          passwordConfirm: "",
          loading: false,
          resetSent: true,
        });
        this.props.history.push("/login");
      })
      .catch((err) => {
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    return (
      <div className={style?.login}>
        <div className={style?.["form-wrapper"]}>
          <div className={style?.form}>
            <div className={style?.logo}>
              <Logo />
            </div>
            <div className={`${style?.["block"]} block`}>
              {this.state.loading ? (
                <Loader />
              ) : (
                <>
                  <h2>{i18n.t("RESET_PASSWORD_TITLE")}</h2>
                  {/* { this.state.error && <p>Email or password not recognized, please try again</p> } */}
                  <form onSubmit={this.reset}>
                    <div className={`${style?.field} field`}>
                      <label>{i18n.t("NEW_PASSWORD")}</label>
                      <input
                        type="password"
                        required
                        value={this.state.password}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                      />
                    </div>
                    <div
                      className={`${style?.field} field ${style?.["last-field"]}`}
                    >
                      <label>{i18n.t("CONFIRM_PASSWORD")}</label>
                      <input
                        type="password"
                        required
                        value={this.state.passwordConfirm}
                        onChange={(e) =>
                          this.setState({ passwordConfirm: e.target.value })
                        }
                      />
                      {this.state.passwordConfirmError && (
                        <div
                          className={`${style["message"]} ${style["error"]}`}
                        >
                          {i18n.t("PASSWORD_NOT_MATCH")}
                        </div>
                      )}
                      {this.state.passwordValidError && (
                        <div
                          className={`${style["message"]} ${style["error"]}`}
                        >
                          {i18n.t("PASSWORD_RULE")}
                        </div>
                      )}
                    </div>
                    <div className={style["btn-group"]}>
                      <button
                        type="button"
                        onClick={this.reset}
                        className={style["single"]}
                      >
                        {i18n.t("CHANGE_PASSWORD")}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordRequest;
